import { h as m } from "vue";
const g = (l, s) => {
  const r = "http://www.w3.org/2000/svg", t = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <path d="M31.4 11.41l-4.92-6.55a.82.82 0 00-.48-.32l-9.87-1.63a.84.84 0 00-.27 0L6 4.54a.82.82 0 00-.52.32L.6 11.41a.82.82 0 000 1l14.79 16.42a.82.82 0 001.22 0l14.74-16.38a.82.82 0 00.05-1.04zm-10-.33L16 25.89l-5.38-14.8zm-10-1.64L16 4.87l4.58 4.58zm7-4.5l6.06 1-2 3-4-4zM9.57 9l-2-3 6.06-1zm-1.48.7l-4.89 1 2.93-3.93zm.83 1.51l4.87 13.4-11-12.18 6.09-1.22zm14.16 0l6.09 1.22-11 12.18 4.87-13.4zm.83-1.51l2-2.93 2.93 3.91z"/>
</svg>
`, "image/svg+xml").firstChild;
  if (l.title) {
    const e = document.createElementNS(r, "title");
    e.textContent = l.title, t.appendChild(e);
  }
  const a = Array.from((t == null ? void 0 : t.attributes) ?? []).reduce((e, n) => ({
    ...e,
    [n.name]: n.value
  }));
  return m(
    "svg",
    {
      ...a,
      ...s.attrs,
      role: "img",
      innerHTML: t.innerHTML
    }
  );
};
export {
  g as default
};
//# sourceMappingURL=SpecialIcon.B6TeHwGZ.js.map
